import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";
import registerImage from "../../static/media/Home/register.webp";

const MotionBox = motion(Box);
const MotionButton = motion(Button);

export default function RegisterInviteSection() {
  const whatsappLink =
    "https://wa.me/593985224301?text=Hola,%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20registro%20de%20NovaXFit.";

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { xs: 4, md: 6 },
        bgcolor: "#ffffff",
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", md: "85%" },
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 380px" },
          gap: { xs: 3, md: 2 },
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            component="h2"
            sx={{
              color: "#111",
              fontWeight: 800,
              lineHeight: 1.05,
              letterSpacing: -1,
              maxWidth: { md: 750 },
              fontSize: {
                xs: "clamp(30px,6vw,38px)",
                md: "clamp(40px,3vw,52px)",
              },
              mb: 1.4,
            }}
          >
            Regístrate y vive la experiencia completa de NovaXFit
          </Typography>

          <Typography
            sx={{
              color: "rgba(17,17,17,0.75)",
              lineHeight: 1.75,
              fontSize: { xs: 15.5, md: 16.5 },
              mb: 2.5,
              maxWidth: { md: 560 },
              mx: { xs: "auto", md: 0 },
              fontWeight: 500,
            }}
          >
            Crea tu cuenta en{" "}
            <Box component="strong" sx={{ fontWeight: 700 }}>
              NovaXFit
            </Box>{" "}
            y lleva el control de tus membresías desde un solo lugar. Accede a
            beneficios con partners, descuentos exclusivos, zonas especiales y
            una experiencia más cómoda, rápida y personalizada dentro de nuestra
            comunidad.
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.2}
            sx={{
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <MotionButton
              component={RouterLink}
              to="/registro"
              variant="contained"
              initial={{ opacity: 0, y: 24, scale: 0.96 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              whileHover={{ y: -3, scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.55, ease: "easeOut" }}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: "16px",
                py: 1.1,
                px: 3,
                fontSize: 15,
                color: "#fff",
                background:
                  "linear-gradient(135deg,#5f0008 0%,#a80d19 40%,#df2632 70%,#161616 100%)",
                boxShadow: "0 12px 35px rgba(229,9,20,0.25)",
                "&:hover": {
                  filter: "brightness(1.05)",
                },
              }}
            >
              Registrarme ahora
            </MotionButton>

            <MotionButton
              component="a"
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              initial={{ opacity: 0, y: 24, scale: 0.96 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              whileHover={{ y: -3, scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.55, delay: 0.08, ease: "easeOut" }}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: "16px",
                py: 1.1,
                px: 3,
                fontSize: 15,
                color: "#111",
                borderColor: "rgba(17,17,17,0.15)",
                "&:hover": {
                  borderColor: "#e50914",
                  color: "#e50914",
                  bgcolor: "rgba(229,9,20,0.05)",
                },
              }}
            >
              Contactar a un asesor
            </MotionButton>
          </Stack>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <MotionBox
            component="img"
            src={registerImage}
            alt="Registro NovaXFit"
            initial={{ opacity: 0, scale: 0.92, y: 30 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, amount: 0.35 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            sx={{
              width: "100%",
              maxWidth: { xs: 230, sm: 280, md: 360 },
              height: "auto",
              objectFit: "contain",
              borderRadius: { xs: "22px", md: "28px" },
              display: "block",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}